import React from 'react'
import "./unauthorizedaccess.css"
import { ReportProblem } from '@mui/icons-material'

const UnauthorizedAccess = () => {
  return (
    <div className='unauthorizedAccessContainer'>
        <ReportProblem className='reportProbLemIcon'/>
        <span className='unauthorizedAccessMessage'>You are not authorized to visit the page !!!</span>
    </div>
  )
}

export default UnauthorizedAccess